import { Box } from "@chakra-ui/react";
import { BESZLA_PUB_META, FORG_FEJ_PUB_META } from "@coimbra-its/api.konyvelo";
import { formatDate, formatMoney1, TableMeta, useWSysLayoutContext, useWSysMainTable, useWSysPage, useWSysPath, WSysPage, WSysSearch, WSysTable, WSysVert } from "@coimbra-its/websys-ux-core";
import { useKonyveloApi } from "../store/konyvelo.api";
import { Beszla } from "./Beszla";
import { WSysTableSettings } from "../temp/TableSettings";
import { Kiszla } from "./Kiszla";

const CELLS = new TableMeta(FORG_FEJ_PUB_META)
	.Only(['P_NEV', 'P_KOD', 'SZLASZ', 'DEV_BRUTTO', 'TELJDAT', 'ROGZDAT', 'FHATDAT'])
	.Map2('DEV_BRUTTO', row => formatMoney1(row.DEV_BRUTTO, row.DEV)).Set('DEV_BRUTTO', {width: '70px'})
	.Set('P_KOD', {charWidth:10, width:'100px'})
	.Set('P_NEV', {charWidth:40, width:'350px'})
	.Map('TELJDAT', val => formatDate(val))
	.Map('ROGZDAT', val => formatDate(val))
	.Map('FHATDAT', val => formatDate(val))

	.forTable();



export function KiszlaLista() {


	const path = useWSysPath();
	const [q] = path.useParam('q');
	
	// ---------------------
	const tableProps = useWSysMainTable(path, [q]);


	// ---------------------

	const api = useKonyveloApi();
	const [szamlaGetRes, hub] = api.kiszlaGet.useData({ q, ...tableProps.forPath });
	const szamlak = szamlaGetRes?.szamlak?.items || [];
	const szamlaPath = path.useChildRow('', szamlak, szamla => szamla.DOKID);

	const layout = useWSysLayoutContext();
	const page = useWSysPage({ title: 'Kimenő számlák', maxCols: 10 /*szamlaPath.isOpen ? (Math.max(layout.widthCols - 4, 2)) : 10 */});
	

	return <WSysPage page={page} hubs={[hub]}

		tools={<Box display='flex' gap={2}>
			<WSysSearch name='q' />
			<WSysTableSettings orderBy={tableProps.forTable.orderBy} orderByChanged={tableProps.forTable.orderByChanged} cells={CELLS} reset={{orderBy:'', title:'Alaphelyzet (ID desc)'}} />
		</Box>}

	>
		<WSysVert mode="rest">
			<WSysTable
				cells={CELLS}
				rows={szamlak}
				tableInfo={szamlaGetRes?.szamlak.info}
				{...szamlaPath.forTable}
				{...tableProps.forTable}
				mode={3}
				noHead={layout.isMobileFull || true}

			/>
		</WSysVert>

		{szamlaPath.on(szamlaPath.forTable.selectedRow && <Kiszla DOKID={szamlaPath.forTable.selectedRow.DOKID}  />)}
	</WSysPage>
}